export default "__VITE_ASSET__daee2619__"